import { useState, useEffect } from "react";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export default function ScrollPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosed, setIsClosed] = useState(false);

  useEffect(() => {
    // Check if popup was closed in this session
    const popupClosed = sessionStorage.getItem("scrollPopupClosed");
    if (popupClosed === "true") {
      setIsClosed(true);
      return;
    }

    const handleScroll = () => {
      const scrollPercentage =
        (window.scrollY /
          (document.documentElement.scrollHeight - window.innerHeight)) *
        100;

      if (scrollPercentage >= 25 && !isClosed) {
        setIsVisible(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isClosed]);

  const handleClose = () => {
    setIsVisible(false);
    setIsClosed(true);
    sessionStorage.setItem("scrollPopupClosed", "true");
  };

  if (!isVisible || isClosed) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 animate-in slide-in-from-bottom-5 duration-500">
      <div className="bg-white rounded-lg shadow-2xl border border-gray-200 p-6 max-w-sm relative">
        <button
          onClick={handleClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 transition z-10 p-1 touch-manipulation"
          aria-label="Close popup"
          type="button"
        >
          <X size={20} />
        </button>

        <div className="mb-4">
          <img
            src="https://cdn.builder.io/api/v1/image/assets%2F2651dca913d34eafa320b193e1b2c34e%2F0360e517297d402aa70b049af6ca59d1?format=webp&width=400"
            alt="Specialized Services"
            className="h-12"
          />
        </div>

        <h3 className="text-xl font-bold text-brand-gray-dark mb-2">
          Get a FREE On-Site Quote Today!
        </h3>

        <p className="text-gray-600 mb-1">
          Get expert advice from our professionals!
        </p>

        <p className="text-sm text-gray-500 mb-4">
          Serving Orange County Residents and Businesses since 1992
        </p>

        <Link to="/free-estimate">
          <Button className="w-full bg-brand-orange hover:brightness-90 font-semibold">
            Request a Quote
          </Button>
        </Link>
      </div>
    </div>
  );
}
